{
  "cms.homeCard.field.title": "Otsikko",
  "cms.homeCard.field.imageUrl": "Kuva",
  "cms.homeCard.field.tab": "Etusivun välilehti",
  "cms.homeCard.field.size": "Kortin koko",
  "cms.homeCard.size.small": "Pieni",
  "cms.homeCard.size.large": "Suuri",
  "cms.homeCard.tab.lakikaveri": "Lakikaveri",
  "cms.homeCard.tab.palvelut": "Jäsenyys ja edut",
  "cms.homeCard.error.titleRequired": "Otsikko on pakollinen.",
  "cms.homeCard.error.imageRequired": "Kuva on pakollinen.",
  "cms.homeCard.error.imageUrl": "Kuva-URL:n on alettava https:// tai oltava sama-alkuperäinen polku (/media/...)."
}
